module.exports = __webpack_public_path__ + "static/media/lfsbi.38bd95e7.png";